import React, { useMemo } from "react";
//#region types
import { FormFieldProps, MonthRangeFormFieldProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import MonthPicker from "../../datePickers/monthPicker";
import { FormControl } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function MonthPickerFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const {
    name,
    field,
    errors,
    touched,
    value,
    hideSuccess,
    handleOnChangeCustom,
    handleOnBlurCustom,
    invertedDisplayType,
    disabled,
    readonly,
  } = props;

  const hasError = !!(errors && touched);
  const extraProps = field.extraProps as MonthRangeFormFieldProps;

  const initialValue = useMemo(() => JSON.stringify(value), []);

  const success = initialValue !== JSON.stringify(value) && !errors ? true : undefined;

  const onChange = (date?: Date) => {
    handleOnChangeCustom(name, date ?? undefined);
  };

  return readonly ? (
    <ReadOnlyField label={field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {!extraProps?.hideDateIfReadOnly && DateHelper.formatMonth(value ?? undefined)}
    </ReadOnlyField>
  ) : (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <MonthPicker
        selected={props.value ?? undefined}
        onChange={onChange}
        error={hasError}
        label={LocalizationHelperInstance.getFormattedMessage(field.label)}
        excludeDates={extraProps?.excludeMonths}
        displayType={invertedDisplayType}
        onBlur={handleOnBlurCustom.bind(null, name)}
        onFocus={field.onFocusHandler}
        success={!hideSuccess && success}
        disabled={disabled}
        placeholderText={field.placeholder}
        popperProps={{ strategy: extraProps?.popperPositionFixed ? "fixed" : "" }}
        minDate={extraProps?.minDate}
        maxDate={extraProps?.maxDate}
        hideClearable={extraProps?.hideClearable}
        setLastDayOfMonth={extraProps?.setLastDayOfMonth}
        popperModifiers={
          extraProps?.popperPositionFixed
            ? [
                {
                  name: "flip",
                  options: {
                    fallbackPlacements: ["left"],
                  },
                },
              ]
            : []
        }
      />
    </FormControl>
  );
}

export default MonthPickerFormField;
